import React from 'react'
import { useSelector } from "react-redux";
import PropTypes from "prop-types"
import { Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { showNotification } from "components/Common/notification";
import { getIntegrationLogo } from 'helpers/component_helpers';
import './services.scss';

const OnShowIntegrationUrlModal = props => {
    const { isOpen, toggle } = props;
    const integrationUrl = useSelector((state) => state.Service.integrationUrl || "");
    const integrationName = useSelector((state) => state.Service.integrationName || "");
    const integrationType = useSelector((state) => state.Service.integrationType || "");
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="exampleModal"
            tabIndex="-1"
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle}>
                    Integration URL Details
                </ModalHeader>
                <ModalBody>
                    {
                        integrationUrl && integrationName && integrationType &&
                        <React.Fragment>
                            <Label className="form-label">Integration Name</Label>
                            <div className="mb-3">
                                <table className="table-dark">
                                    <tbody className="table-dark">
                                        <tr>
                                            <td>
                                                <Input name={"integrationName"} className="form-control" type="text" readOnly={true}
                                                    value={integrationName} style={{ backgroundColor: 'transparent' }} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <Label className="form-label">Integration Type</Label>
                            <div className="mb-3">
                                <table className="table-purple">
                                    <tbody className="table-dark">
                                        <tr>
                                            <td className='integration-cell'>
                                                <img className="avatar-xs rounded-circle" src={getIntegrationLogo(integrationType)} alt={integrationType} />
                                                <h6 className='mt-2'>{integrationType}</h6>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <Label className="form-label">Integration URL</Label>
                            <div className="mb-3">
                                <table className="table-purple">
                                    <tbody className="table-dark">
                                        <tr>
                                            <td>
                                                <Input name={"integrationUrl"} className="form-control" style={{ backgroundColor: 'transparent' }}
                                                    placeholder="URL" type="text" readOnly={true}
                                                    value={integrationUrl} />
                                            </td>
                                            <td className="align-items-center justify-content-center">
                                                <i className="bx bx-copy bx-sm" onClick={
                                                    () => {
                                                        if (navigator.clipboard) {
                                                            navigator.clipboard.writeText(integrationUrl)
                                                                .then(() => {
                                                                    showNotification("success", "Key copied to clipboard");
                                                                })
                                                                .catch((error) => {
                                                                    showNotification("error", error);
                                                                    console.error('Error copying text to clipboard: ', error);
                                                                });
                                                        } else {
                                                            try {
                                                                const textArea = document.createElement('textarea');
                                                                textArea.value = integrationUrl;
                                                                document.body.appendChild(textArea);
                                                                textArea.select();
                                                                document.execCommand('copy');
                                                                document.body.removeChild(textArea);
                                                                showNotification("success", "Key copied to clipboard");
                                                            } catch (error) {
                                                                showNotification("error", error);
                                                                console.error('Error copying text to clipboard using fallback method: ', error);
                                                            }
                                                        }
                                                    }
                                                } style={{ cursor: 'pointer' }} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </React.Fragment>
                    }
                </ModalBody>
            </div>
        </Modal>
    )
}

OnShowIntegrationUrlModal.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
}

export default OnShowIntegrationUrlModal;